<script>
import { v1 as uuid } from "uuid";
export default {
  props: {
    alertclosingbutton: {
      type: Boolean,
      required: true
    },
    cookieexpiration: {
      type: String,
      required: true
    },
    cookiename: {
      type: String,
      required: true
    },
    ctainputedurl: {
      type: String,
      required: false
    },
    ctalabel: {
      type: String,
      required: false
    },
    ctatheme: {
      type: String,
      required: true
    },
    partialpath: {
      type: String,
      required: true,
    },
    siteclingmessage: {
      type: String,
      required: false,
    },
    siteclingtheme: {
      type: String,
      required: true,
    },
     submittarget: {
      type: String,
      required: false,
    },
    trackingCookie:{
      type: String,
      required: false
    }
  },
  data() {
    return {
      siteclingisvisible: true,
      cookiename: '',
      cookieexpiration: '',
      ctaurl: this.submitCtaUrl,
      id: uuid(),
      siteclingHeight: 0,
      trackingCookie: this.trackingCookie    
  }; 
  },
  mounted() {
  },
  methods: {
    setalertclosecookievalue() {
      const cookie = $cookies.get(this.cookiename);
      const siteclingExpireDate = new Date(this.cookieexpiration).toUTCString();
      $cookies.remove(this.cookiename);
      $cookies.set(
         this.cookiename,
         "UserClosedAlert",
         siteclingExpireDate,
         "/",
         null,
         true,
         "None"
      );
      this.siteclingisvisible = false;
    },
  },
  computed: {
    submitCtaUrl() {
      return this.ctainputedurl
      + this.trackingCookie
    },
    goToUrl() {
      window.open(this.submitCtaUrl, this.submittarget);
    },
  },
};
</script>

<template>
  <div class="sitecling__container">
    <div v-if="siteclingisvisible" aria-label="Alert" class="sitecling__panel" :class="`${siteclingtheme}`" :id="id + '-panel'" :key="id" role="region" :style="`display: siteclingisvisible ? 'flex' : 'none'`">
      <div class="sitecling__message-container">  
        
        <div class="sitecling__content">
           <div v-if="this.siteclingmessage" class="wysiwyg" v-html="this.siteclingmessage"></div>
        </div>
        
        <div v-if="ctalabel && ctainputedurl" class="sitecling__cta">
          <div class="btn"
            :class="`${ctatheme}`"
            @click="goToUrl();">
            <span class="btn__content">
              <span class="btn__text">{{ ctalabel }}</span>
            </span>
          </div>
        </div>

      </div>

      <div v-if="alertclosingbutton === true" @click="setalertclosecookievalue" class="sitecling__close-bt" :id="id + '-button'" :aria-controls="id + '-panel'">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15.983"><path d="M1.772 0A1.774 1.774 0 00.537 3.046L5.491 8 .537 12.955a1.774 1.774 0 102.509 2.509L8 10.509l4.954 4.954a1.774 1.774 0 102.509-2.509L10.508 8l4.954-4.954A1.774 1.774 0 1012.954.538L7.999 5.492 3.045.537A1.774 1.774 0 001.772 0z"></path></svg>
      </div>

    </div><!-- /sitecling panel -->
  </div><!-- /sitecling container -->
</template>


